import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { HelmetProvider } from "react-helmet-async";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>,
);

// Remove platform-injected badges
setInterval(() => {
  const badge = document.getElementById('emergent-badge');
  if (badge) badge.remove();
  document.querySelectorAll('a[href*="emergent-badge"]').forEach(el => el.remove());
}, 500);
